module.exports = __webpack_public_path__ + "img/usdt.90e435bb.svg";